export default __webpack_public_path__ + "img/e15b5efab297e4db06d1e2749f2b4e20.svg";